<!--
 * @Date: 2020-07
 * @LastEditTime: 2020-07-22 15:50
 * @Description: 文字超长就... 鼠标移上去就显示全部内容
--> 
<template>
  <div class="text-over-tooltip-components " >
    <el-popover :placement="placement" trigger="hover" :disabled="isDisabledPopover" >
      <div class="font12" >{{content}}</div>
      <div class="ellips"  slot="reference" :class="className" @mouseover="onMouseOver(refName)">
        <span :ref="refName">{{content}}</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'eltip',
  props: {
    content: String,// 显示的文字内容
    className: String,
    refName: {
      type: String,
      default: () => {
        return 'ref';  // Tooltip 的出现位置
      }
    },// 子元素标识（如在同一页面中调用多次组件，此参数不可重复）
    placement: {
      type: String,
      default: () => {
        return 'bottom';  // Tooltip 的出现位置
      }
    },
  },
  data() {
    return {
      isDisabledPopover: true // 是否需要禁止提示
    };
  },
  methods: {
    // 移入事件: 判断内容的宽度contentWidth是否大于父级的宽度
    onMouseOver(str) {
      let parentWidth = this.$refs[str].parentNode.offsetWidth;
      let contentWidth = this.$refs[str].offsetWidth;
      // 判断是否禁用tooltip功能
      this.isDisabledPopover = contentWidth <= parentWidth-10;
    }
  }
};
</script>

<style lang="scss" scoped>
.text-over-tooltip-components{
  /* 文字超出宽度显示省略号 单行 */
  .ellips {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/elTip.vue